export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="69" height="69" viewBox="0 0 69 69" fill="none">
            <path d="M1 0.685547L68 67.6855" stroke="#674A29" strokeOpacity="0.5" />
        </svg>
    );
}
